"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconFacebookPost = void 0;
var React = __importStar(require("react"));
var IconFacebookPost = function (props) { return (React.createElement("svg", __assign({ width: "34px", height: "34px", viewBox: "0 0 34 34" }, props),
    React.createElement("defs", null,
        React.createElement("polygon", { id: "path-1", points: "10 8 24 8 24 34 10 34" })),
    React.createElement("g", { id: "Facebook-post", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
        React.createElement("g", { id: "Post-Facebook" },
            React.createElement("rect", { id: "Background", fill: "#3B5998", x: 0, y: 0, width: 34, height: 34, rx: 4 }),
            React.createElement("mask", { id: "mask-2", fill: "white" },
                React.createElement("use", { xlinkHref: "#path-1" })),
            React.createElement("g", { id: "Clip-2" }),
            React.createElement("path", { d: "M23.2150505,23.4031574 L23.8329764,18.3680196 L19.0874885,18.3680196 L19.0874885,15.153572 C19.0874885,13.695863 19.4723157,12.7026863 21.4620679,12.7026863 L24,12.7015615 L24,8.19844253 C23.5610278,8.13722261 22.0546039,8 20.3016213,8 C16.643316,8 14.1382686,10.3464423 14.1382686,14.6552965 L14.1382686,18.3680196 L10,18.3680196 L10,23.4031574 L14.1382686,23.4031574 L14.1382686,36 C15.8600489,35.9845745 17.5218721,35.7061122 19.0874885,35.1965889 L19.0874885,23.4031574 L23.2150505,23.4031574 Z", id: "Fill-1", fill: "#FFFFFF", mask: "url(#mask-2)" }))))); };
exports.IconFacebookPost = IconFacebookPost;
exports.IconFacebookPost.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconFacebookPost;
